// eslint-disable-next-line no-restricted-imports
import {
  Configuration,
  DefaultApiConfirmUserFeedbackRequest as IUserFeedbackConfirmRequest,
  DefaultApiCreateUserFeedbackRequest as IUserFeedbackCreateRequest,
  DefaultApiDeleteAttachmentRequest as IUserFeedbackDeleteAttachmentRequest,
  DefaultApiDeleteUserFeedbackRequest as IUserFeedbackDeleteRequest,
  DefaultApiUploadAttachmentRequest as IUserFeedbackUploadAttachmentRequest,
  DefaultApi as UserFeedbackApi,
} from '@eih-netbroker/api-user-feedback';
import { AxiosInstance, AxiosProgressEvent } from 'axios';
import { IConfigAPI } from '../config';
import { ResourceHeadersWithToken } from '../services/useResource';
import { BaseResource } from './base.resource';

export type UserFeedbackCreateRequest = Omit<IUserFeedbackCreateRequest, keyof ResourceHeadersWithToken>;

export type UserFeedbackConfirmRequest = Omit<IUserFeedbackConfirmRequest, keyof ResourceHeadersWithToken>;

export type UserFeedbackUploadAttachmentRequest = Omit<
  IUserFeedbackUploadAttachmentRequest,
  keyof ResourceHeadersWithToken
>;

export type UserFeedbackDeleteAttachmentRequest = Omit<
  IUserFeedbackDeleteAttachmentRequest,
  keyof ResourceHeadersWithToken
>;

export type UserFeedbackDeleteRequest = Omit<IUserFeedbackDeleteRequest, keyof ResourceHeadersWithToken>;

export class UserFeedbackResource extends BaseResource {
  // Name has to be overridden, since the build job renames it to 'r' and
  // every resource class will have the same name
  // @ts-ignore
  static readonly name = 'UserFeedbackResource';

  private userFeedbackApi: UserFeedbackApi;

  constructor(axiosInstance: AxiosInstance, basePath: string, configApi: IConfigAPI) {
    console.log('UserFeedbackResource', configApi.usUrl.userFeedback, configApi);
    super(axiosInstance, `${basePath}${configApi.usUrl.userFeedback}`, configApi);
    this.userFeedbackApi = new UserFeedbackApi(
      new Configuration({
        basePath: `${basePath}${configApi.usUrl.userFeedback}`,
      }),
      `${basePath}${configApi.usUrl.userFeedback}`,
      axiosInstance,
    );
  }

  async createUserFeedback(request: UserFeedbackCreateRequest, headers: ResourceHeadersWithToken) {
    return this.userFeedbackApi.createUserFeedback(
      { ...request, ...headers },
      {
        baseURL: `${this.configApi.usUrl.baseUrl}${this.configApi.usUrl.userFeedback}`,
      },
    );
  }

  async confirmUserFeedback(request: UserFeedbackConfirmRequest, headers: ResourceHeadersWithToken) {
    return this.userFeedbackApi.confirmUserFeedback(
      { ...request, ...headers },
      {
        baseURL: `${this.configApi.usUrl.baseUrl}${this.configApi.usUrl.userFeedback}`,
      },
    );
  }

  async deleteUserFeedback(request: UserFeedbackDeleteRequest, headers: ResourceHeadersWithToken) {
    return this.userFeedbackApi.deleteUserFeedback(
      { ...request, ...headers },
      {
        baseURL: `${this.configApi.usUrl.baseUrl}${this.configApi.usUrl.userFeedback}`,
      },
    );
  }

  async uploadAttachment(
    request: UserFeedbackUploadAttachmentRequest,
    headers: ResourceHeadersWithToken,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
    abortController?: AbortController,
  ) {
    return this.userFeedbackApi.uploadAttachment(
      { ...request, ...headers },
      {
        onUploadProgress,
        signal: abortController?.signal,
        baseURL: `${this.configApi.usUrl.baseUrl}${this.configApi.usUrl.userFeedback}`,
      },
    );
  }

  async deleteAttachment(request: UserFeedbackDeleteAttachmentRequest, headers: ResourceHeadersWithToken) {
    return this.userFeedbackApi.deleteAttachment(
      { ...request, ...headers },
      {
        baseURL: `${this.configApi.usUrl.baseUrl}${this.configApi.usUrl.userFeedback}`,
      },
    );
  }
}
